import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
function useResizeObserver(targetRef, onSizeChange, observeIf = true) {
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        const resizeObserver = new ResizeObserver((entries = [])=>{
            if (entries[0]) {
                const { contentRect } = entries[0];
                const { height = 0, top = 0 } = contentRect;
                const size = height + 2 * top;
                onSizeChange(size);
            }
        });
        if ((null == targetRef ? void 0 : targetRef.current) && observeIf) resizeObserver.observe(targetRef.current);
        return ()=>{
            resizeObserver.disconnect();
            onSizeChange(0);
        };
    }, [
        targetRef,
        onSizeChange,
        observeIf
    ]);
}
export { useResizeObserver };
